module.exports = __webpack_public_path__ + "static/media/twitter.49964d82.png";